var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppTitle',{class:{
    'Title--beta': _vm.level === 2,
    'Title--gama': _vm.level === 3,
    'Title--delta': _vm.level === 4,
    'Title--epsilon': _vm.level === 5 },attrs:{"heading-level":_vm.level}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }